import React, { FC, useCallback } from 'react'

import { ReactComponent as BarsMenu } from '../../assets/icons/newTheme/bars-menu.svg'
import { ReactComponent as Chevron } from '../../assets/icons/newTheme/chevron.svg'

import { sectionHeadline, collapsibleSection, collapsibleContent, icon, indicator } from './index.css'

type CollapsibleSectionProps = {
  title: string
  children: React.ReactNode
  showIcon?: boolean
  showIndicator?: boolean
  defaultOpen?: boolean
  disabled?: boolean
}

const CollapsibleSection: FC<CollapsibleSectionProps> = ({
  title,
  children,
  showIcon,
  showIndicator = true,
  defaultOpen = false,
  disabled = false
}) => {
  const [isOpened, setIsOpened] = React.useState(defaultOpen)

  const handleToggle = useCallback(() => {
    setIsOpened(prev => !prev)
  }, [])

  return (
    <section className={collapsibleSection({ disabled })}>
      <div className={sectionHeadline} onClick={disabled ? undefined : handleToggle}>
        {showIcon && <BarsMenu className={icon} />}
        <h5>{title}</h5>
        {showIndicator && <Chevron className={indicator({ state: isOpened ? 'opened' : 'closed' })} />}
      </div>
      {isOpened && <div className={collapsibleContent}>{children}</div>}
    </section>
  )
}

export default CollapsibleSection
